/* ==========================================================================
   Shestia : fiche produit, points clés, suggestions, quick view (module FICHE, 02/10/2026). Écrit de zéro.
   Comportements relevés sur la référence (:8190) et reproduits ici :
   - carrousels : 300 ms, ease ; glisser au doigt ou à la souris ; flèches désactivées aux bouts ;
   - galerie d'ordinateur : la vignette active change d'un coup, d'après la part visible de chaque vue relevée à ses
     passages par 0, 25, 50, 75 et 100 % ; la liste des vignettes monte d'un pas quand la troisième devient active ; un
     clic amène la vue au milieu de l'écran ; les flèches du rail passent à la vue précédente ou suivante, en boucle ;
   - couleur choisie : galerie de la couleur, adresse ?variant=<id> (sans recharger), barre collante à jour ;
   - « Where’s the discount? » : hauteur 0 -> contenu en 0.6 s cubic-bezier(.4,0,.2,1) ;
   - barre d'achat collante : visible quand le bouton d'ajout est hors de l'écran, retirée dès que le pied de page
     entre dans l'écran ;
   - onglets des points clés : la carte sortante s'efface en descendant de 20 px (300 ms), la forme du fond avec
     elle ; l'entrante monte de 20 px (300 ms) ;
   - « You may also like » : le carrousel se place sur sa deuxième carte quand il peut défiler (390 et 1024 sur la
     référence), avant d'entrer dans l'écran : dès que son haut est à moins de 300 px sous le bas de l'écran ;
   - quick view : rendu de la section sh-quick-view dans le contexte de la robe (?section_id=), tiroir « quickview ».
   Dépend de assets/sh-core.js (window.Shestia, SOCLE) quand il est là ; sinon les routes Ajax de Shopify.
   ========================================================================== */
(function () {
  'use strict';

  var S = (window.Shestia = window.Shestia || {});
  // fichier lié deux fois sur une même page (une section d'une autre équipe qui le lie aussi) : une seule exécution,
  // sinon les écouteurs du document (quick view, variantes) seraient posés deux fois
  if (S.__ficheChargee) return;
  S.__ficheChargee = true;
  function qsa(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function emit(el, name, detail) {
    el.dispatchEvent(new CustomEvent(name, { detail: detail || {}, bubbles: true }));
  }
  function reduit() { return !!(S.reducedMotion || (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches)); }
  function animer(el, images, opts) {
    if (!el.animate || reduit()) {
      var fin = images[images.length - 1];
      for (var k in fin) if (k !== 'offset') el.style[k] = fin[k];
      return { finished: Promise.resolve(), cancel: function () {} };
    }
    var a = el.animate(images, opts);
    if (!a.finished) a.finished = new Promise(function (r) { a.onfinish = r; });
    return a;
  }
  function definir(nom, classe) { if (!customElements.get(nom)) customElements.define(nom, classe); }

  /* ------------------------------------------------------------------ carrousel */
  class ShSlider extends HTMLElement {
    connectedCallback() {
      if (this._pret) return;
      this._pret = true;
      this.track = this.querySelector('.sh-slider__track');
      if (!this.track) return;
      this.index = 0;
      this.speed = parseInt(this.getAttribute('data-speed') || '300', 10);
      var zone = this.parentElement || this;
      this.prev = zone.querySelector('[data-sh-slider-prev]');
      this.next = zone.querySelector('[data-sh-slider-next]');
      var self = this;
      if (this.prev) this.prev.addEventListener('click', function () { self.go(self.index - 1); });
      if (this.next) this.next.addEventListener('click', function () { self.go(self.index + 1); });
      this.lier();
      this.mesurer();
      if (window.ResizeObserver) {
        this._ro = new ResizeObserver(function () { self.mesurer(); });
        this._ro.observe(this);
      } else {
        window.addEventListener('resize', function () { self.mesurer(); });
      }
    }
    disconnectedCallback() { if (this._ro) this._ro.disconnect(); }
    slides() { return qsa(':scope > .sh-slider__slide', this.track).filter(function (s) { return !s.hidden; }); }
    parVue() {
      var v = getComputedStyle(this).getPropertyValue('--sh-per-view').trim() || this.getAttribute('data-per-view') || '1';
      return Math.max(1, parseFloat(v) || 1);
    }
    ecart() { return parseFloat(this.getAttribute('data-gap') || '0') || 0; }
    mesurer() {
      var pv = this.parVue(), gap = this.ecart(), l = this.clientWidth;
      if (!l) return;
      // largeurs arrondies vers le bas et dernière position calée sur le bout de la piste (relevé à 1024 :
      // cartes de 324 px, fin à -322 px) ; data-exact : largeur fractionnaire (vignettes « Second dress », relevées à
      // 314,667 px à 1024 et 97,333 px à 1100, sonde_largeurs_cartes.py)
      var brute = (l - gap * (pv - 1)) / pv;
      this.largeur = this.hasAttribute('data-exact') ? brute : Math.floor(brute);
      var self = this;
      qsa(':scope > .sh-slider__slide', this.track).forEach(function (s) {
        s.style.width = self.largeur + 'px';
        s.style.marginRight = gap + 'px';
      });
      var n = this.slides().length;
      this.fin = Math.max(0, n * this.largeur + (n - 1) * gap - l);
      this.max = this.fin > 0 ? Math.ceil(this.fin / (this.largeur + gap) - 0.001) : 0;
      this.go(Math.min(this.index, this.max), false);
    }
    position(i) { return -Math.min(i * (this.largeur + this.ecart()), this.fin || 0); }
    go(i, anime) {
      if (this.max == null) this.mesurer();
      i = Math.max(0, Math.min(this.max || 0, i));
      var change = i !== this.index;
      this.index = i;
      // glissement gardé en animations réduites : la référence l'y garde (sonde_reduit.py, 390 : piste en mouvement à 40 ms)
      this.track.style.transitionDuration = (anime === false ? 0 : this.speed) + 'ms';
      this.track.style.transform = 'translate3d(' + this.position(i) + 'px, 0, 0)';
      // galerie : aux bouts, les flèches restent pleines (référence) ; suggestions : la flèche du bout s'estompe
      if (this.hasAttribute('data-arrows-state')) {
        if (this.prev) this.prev.classList.toggle('is-end', i <= 0);
        if (this.next) this.next.classList.toggle('is-end', i >= (this.max || 0));
      }
      if (change) emit(this, 'sh:slider:change', { index: i });
    }
    reset() { this.index = 0; this.mesurer(); this.go(0, false); }
    lier() {
      var self = this, depart = null;
      this.addEventListener('pointerdown', function (e) {
        if (e.button !== 0 || (self.max || 0) === 0) return;
        depart = { x: e.clientX, y: e.clientY, t: Date.now(), base: self.position(self.index), id: e.pointerId, dx: 0, actif: false };
      });
      this.addEventListener('pointermove', function (e) {
        if (!depart || e.pointerId !== depart.id) return;
        var dx = e.clientX - depart.x, dy = e.clientY - depart.y;
        if (!depart.actif) {
          if (Math.abs(dx) < 6 && Math.abs(dy) < 6) return;
          if (Math.abs(dy) > Math.abs(dx)) { depart = null; return; }
          depart.actif = true;
          self.classList.add('is-dragging');
          try { self.setPointerCapture(e.pointerId); } catch (err) { /* rien */ }
        }
        depart.dx = dx;
        var x = depart.base + dx, min = self.position(self.max || 0);
        if (x > 0) x = x * 0.15;                       // résistance aux bouts
        if (x < min) x = min + (x - min) * 0.15;
        self.track.style.transitionDuration = '0ms';
        self.track.style.transform = 'translate3d(' + x + 'px, 0, 0)';
      });
      function fin(e) {
        if (!depart || (e && e.pointerId !== depart.id)) return;
        var d = depart; depart = null;
        self.classList.remove('is-dragging');
        if (!d.actif) return;
        var rapide = Date.now() - d.t < 300 && Math.abs(d.dx) > 20;
        var cible = self.index;
        if (Math.abs(d.dx) > self.largeur / 2 || rapide) cible += d.dx < 0 ? 1 : -1;
        self.go(cible);
        self._glisse = Date.now();
      }
      this.addEventListener('pointerup', fin);
      this.addEventListener('pointercancel', fin);
      // un glissé ne vaut pas un clic sur une carte
      this.addEventListener('click', function (e) { if (self._glisse && Date.now() - self._glisse < 80) { e.preventDefault(); e.stopPropagation(); } }, true);
    }
  }
  definir('sh-slider', ShSlider);

  /* ------------------------------------------------------------------ galerie */
  class ShGallery extends HTMLElement {
    connectedCallback() {
      if (this._pret) { if (!this._io) this.observer(); return; }   // galerie déplacée dans la page : le suivi reprend
      this._pret = true;
      var self = this;
      this.slider = this.querySelector('sh-slider');
      qsa('.sh-gallery__thumb', this).forEach(function (b) {
        b.addEventListener('click', function () { self.allerA(self.vues().indexOf(self.vueDe(b))); });
      });
      // flèches du rail : vue précédente ou suivante, en boucle (référence : la flèche du bas, sur la dernière vue,
      // ramène à la première ; la flèche du haut, sur la première, mène à la dernière)
      qsa('.sh-gallery__step', this).forEach(function (b) {
        b.addEventListener('click', function () { self.allerA(self.actif + parseInt(b.getAttribute('data-sh-step'), 10), true); });
      });
      // au départ la première vignette est active, où que soit la page (référence : page rechargée à 1000 px de
      // défilement, vignette 1 active alors que la vue 2 est à l'écran)
      this.actif = 0;
      this.numeroter();
      this.marquer();
      this.observer();
    }
    disconnectedCallback() {
      if (this._io) { this._io.disconnect(); this._io = null; }
      clearTimeout(this._tVerrou);
    }
    // Vignette active au défilement. Règle relevée sur la référence le 04/10 (sonde_vignettes_seuil.py, écrans de 400,
    // 600, 700, 900 et 1100 px de haut, descente et remontée, page rechargée en cours de défilement) : la part visible
    // de chaque vue n'est connue qu'à ses passages par 0, 25, 50, 75 et 100 % ; la vignette active est celle de la vue
    // dont la dernière part connue est la plus grande. À 1440 x 900 : vignette 2 à 441 px en descendant (la vue 1 passe
    // sous 50 %), vignette 1 à 276 px en remontant. L'état de départ n'est pas retenu : seuls comptent les passages
    // faits après le chargement (ou après un changement de couleur).
    observer() {
      var self = this;
      if (this._io) this._io.disconnect();
      this._io = null;
      this._parts = new Map();
      this._verrou = false;
      clearTimeout(this._tVerrou);
      if (!('IntersectionObserver' in window)) return;
      var depart = true;
      var io = this._io = new IntersectionObserver(function (entrees) {
        if (io !== self._io) return;
        if (depart) { depart = false; return; }
        // pendant le défilement lancé par un clic sur une vignette ou une flèche, rien n'est retenu (référence)
        if (self._verrou) return;
        entrees.forEach(function (e) { self._parts.set(e.target, e.isIntersecting ? e.intersectionRatio : 0); });
        self.suivre();
      }, { threshold: [0, 0.25, 0.5, 0.75, 1] });
      this.vues().forEach(function (v) { io.observe(v); });
    }
    suivre() {
      var self = this, meilleur = -1, part = 0;
      this.vues().forEach(function (v, i) {
        var p = self._parts.get(v);
        if (p != null && p > part) { part = p; meilleur = i; }
      });
      if (meilleur >= 0 && meilleur !== this.actif) { this.actif = meilleur; this.marquer(); }
    }
    vues() { return qsa('.sh-gallery__item', this).filter(function (x) { return !x.hidden; }); }
    vignettes() { return qsa('.sh-gallery__thumb', this).filter(function (x) { return !x.hidden; }); }
    vueDe(vignette) {
      var i = qsa('.sh-gallery__thumb', this).indexOf(vignette);
      return qsa('.sh-gallery__item', this)[i];
    }
    numeroter() {
      this.vignettes().forEach(function (b, i) { b.setAttribute('aria-label', 'Open media ' + (i + 1) + ' in modal'); });
    }
    // Clic sur une vignette ou une flèche : la vignette devient active tout de suite, la vue vient au milieu de la
    // hauteur de l'écran (référence, vue 2 : 727 px de défilement à 900 px de haut, 827 px à 700 px de haut).
    allerA(i, boucle) {
      var vues = this.vues(), self = this;
      if (!vues.length) return;
      var n = vues.length;
      i = boucle ? ((i % n) + n) % n : Math.max(0, Math.min(n - 1, i));
      var r = vues[i].getBoundingClientRect();
      var y = Math.max(0, r.top + window.scrollY - (window.innerHeight - r.height) / 2);
      this.actif = i;
      this.marquer();
      // le suivi au défilement repart de zéro, et reste sourd tant que la page va vers la vue (référence : aucune
      // autre vignette ne s'allume en chemin, et ce qui s'est passé en chemin n'est pas retenu)
      this._parts = new Map();
      this._verrou = true;
      clearTimeout(this._tVerrou);
      var liberer = function () { self._verrou = false; clearTimeout(self._tVerrou); };
      // Courbe relevée sur la référence image par image (04/10, sonde_vignettes_defilement.py, 1440) :
      // mode normal : 0,8 s, sortie exponentielle 1 - 2^(-10 t) (58 % du trajet à 100 ms, 82 % à 200, 93 % à 300) ;
      // animations réduites : saut immédiat (une seule image). « duration: 0 » ne suffit pas : Lenis retombe alors sur
      // son lissage par défaut (2 s mesurées) ; il faut « immediate ».
      if (reduit()) {
        if (S.lenis && typeof S.lenis.scrollTo === 'function') S.lenis.scrollTo(y, { immediate: true });
        else window.scrollTo({ top: y, behavior: 'instant' });
        liberer();
        return;
      }
      // filet : un défilement coupé par la molette ne rappelle pas « onComplete »
      this._tVerrou = setTimeout(liberer, 1000);
      if (S.lenis && typeof S.lenis.scrollTo === 'function') {
        S.lenis.scrollTo(y, { duration: 0.8, easing: function (t) { return Math.min(1, 1.001 - Math.pow(2, -10 * t)); }, onComplete: liberer });
      } else {
        window.scrollTo({ top: y, behavior: 'smooth' });
      }
    }
    marquer() {
      var vig = this.vignettes(), actif = this.actif;
      qsa('.sh-gallery__thumb', this).forEach(function (b) { b.classList.remove('is-active'); });
      if (vig[actif]) vig[actif].classList.add('is-active');
      // la vignette active vient à la deuxième place de la fenêtre : la liste monte d'un pas (117 px) quand la troisième
      // devient active, même s'il n'y en a que trois (référence : 350 ms, la place du bas reste vide)
      var piste = this.querySelector('.sh-gallery__track');
      if (piste) piste.style.transform = 'translate3d(0, ' + (-Math.max(0, actif - 1) * 117) + 'px, 0)';
    }
    setColour(couleur) {
      var items = qsa('[data-sh-colour]', this);
      var existe = items.some(function (x) { return x.getAttribute('data-sh-colour') === couleur; });
      items.forEach(function (x) { x.hidden = existe && x.getAttribute('data-sh-colour') !== couleur; });
      this.setAttribute('data-colour', couleur);
      this.numeroter();
      // nouvelle galerie : première vignette active et suivi remis à zéro, où que soit la page (référence : couleur
      // changée à 500 px de défilement, vignette 1 active, puis vignette 2 à 644 px quand la vue 2 est entière)
      this.actif = 0;
      this.marquer();
      this.observer();
      if (this.slider && this.slider.reset) this.slider.reset();
    }
    premiereImage() {
      var v = this.vues()[0] || qsa('.sh-slider__slide', this).filter(function (x) { return !x.hidden; })[0];
      return v ? v.querySelector('img') : null;
    }
  }
  definir('sh-gallery', ShGallery);

  /* ------------------------------------------------------------------ sélecteur de variante */
  class ShVariantPicker extends HTMLElement {
    connectedCallback() {
      if (this._pret) return;
      this._pret = true;
      var self = this;
      try { this.variantes = JSON.parse((this.querySelector('[data-sh-variants]') || {}).textContent || '[]'); }
      catch (e) { this.variantes = []; }
      this.addEventListener('change', function (e) {
        if (e.target && e.target.matches('.sh-variants__input')) self.choisir();
      });
      qsa('[data-sh-more]', this).forEach(function (b) {
        b.addEventListener('click', function () {
          var set = b.closest('.sh-variants__set');
          if (set) set.classList.add('is-unfolded');
        });
      });
    }
    options() {
      return qsa('.sh-variants__set', this).map(function (set) {
        var c = set.querySelector('.sh-variants__input:checked');
        return c ? c.value : null;
      });
    }
    variante() {
      var opts = this.options();
      return this.variantes.find(function (v) {
        return (v.options || []).every(function (o, i) { return opts[i] == null || o === opts[i]; });
      }) || null;
    }
    replier(set, choisie) {
      // référence : après un choix, les couleurs se replient (huit visibles + la choisie, « +N » pour le reste)
      if (!set.hasAttribute('data-sh-folded')) return;
      set.classList.remove('is-unfolded');
      var caches = 0;
      qsa('.sh-swatch', set).forEach(function (lab, i) {
        var champ = document.getElementById(lab.getAttribute('for'));
        var extra = i >= 8 && !(champ && champ.value === choisie);
        lab.classList.toggle('sh-swatch--extra', extra);
        if (extra) caches++;
      });
      var plus = set.querySelector('[data-sh-more]');
      if (plus) { plus.textContent = '+' + caches; plus.hidden = caches === 0; }
    }
    choisir() {
      var opts = this.options(), v = this.variante(), self = this;
      qsa('.sh-variants__set', this).forEach(function (set, i) {
        var val = set.querySelector('[data-sh-option-value]');
        if (val && opts[i] != null) val.textContent = opts[i];
        self.replier(set, opts[i]);
      });
      // sans parent qui s'en charge : le formulaire visé suit la variante
      var formId = this.getAttribute('data-form');
      if (v && formId && !this.closest('sh-product, [data-sh-qv-root]')) {
        var f = document.getElementById(formId);
        var champ = f && f.querySelector('[data-sh-variant-id]');
        if (champ) champ.value = v.id;
      }
      emit(this, 'sh:variant:change', { variant: v, options: opts, picker: this });
    }
  }
  definir('sh-variant-picker', ShVariantPicker);

  /* ------------------------------------------------------------------ quantité */
  class ShQty extends HTMLElement {
    connectedCallback() {
      if (this._pret) return;
      this._pret = true;
      var self = this;
      this.input = this.querySelector('input');
      qsa('[data-sh-step]', this).forEach(function (b) {
        b.addEventListener('click', function () {
          var v = (parseInt(self.input.value, 10) || 1) + parseInt(b.getAttribute('data-sh-step'), 10);
          self.input.value = Math.max(1, v);
          self.maj();
          self.input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
      this.input.addEventListener('change', function () { self.input.value = Math.max(1, parseInt(self.input.value, 10) || 1); self.maj(); });
      this.maj();
    }
    maj() {
      var moins = this.querySelector('[data-sh-step="-1"]');
      if (moins) moins.disabled = (parseInt(this.input.value, 10) || 1) <= 1;
    }
  }
  definir('sh-qty', ShQty);

  /* ------------------------------------------------------------------ formulaire d'achat */
  function ajouterAuPanier(form) {
    if (S.cart && typeof S.cart.add === 'function') return S.cart.add(form);
    var fd = new FormData(form);
    return fetch('/cart/add.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(fd.get('id')), quantity: Number(fd.get('quantity') || 1) }] })
    }).then(function (r) { return r.json().then(function (d) { if (!r.ok || d.status) throw new Error(d.description || d.message || 'Cart error'); return d; }); });
  }
  class ShBuyForm extends HTMLElement {
    connectedCallback() {
      if (this._pret) return;
      this._pret = true;
      var self = this;
      this.form = this.querySelector('form');
      this.erreur = this.querySelector('[role="alert"]');
      if (!this.form) return;
      this.form.addEventListener('submit', function (e) {
        e.preventDefault();
        self.envoyer();
      });
    }
    envoyer() {
      var self = this, bouton = this.form.querySelector('[type="submit"]');
      if (!bouton || bouton.disabled || this.classList.contains('is-loading')) return;
      // la quantité vit dans le formulaire principal ; la barre collante envoie 1, comme la référence
      this.classList.add('is-loading');
      bouton.setAttribute('aria-busy', 'true');
      if (this.erreur) this.erreur.hidden = true;
      ajouterAuPanier(this.form).then(function () {
        self.classList.remove('is-loading');
        bouton.removeAttribute('aria-busy');
        var fd = new FormData(self.form);
        emit(self, 'sh:product:added', { variant: Number(fd.get('id')), quantity: Number(fd.get('quantity') || 1) });
        if (S.drawers && S.drawers.get && S.drawers.get('cart')) {
          if (!S.drawers.isOpen('cart')) S.drawers.open('cart', { retour: bouton });
        }
      }).catch(function (err) {
        self.classList.remove('is-loading');
        bouton.removeAttribute('aria-busy');
        if (self.erreur) {
          var t = self.erreur.querySelector('[data-sh-error]');
          if (t) t.textContent = (err && err.message) || 'Something went wrong. Please try again.';
          self.erreur.hidden = false;
        }
      });
    }
  }
  definir('sh-buy-form', ShBuyForm);

  /* ------------------------------------------------------------------ « Where’s the discount? » */
  class ShDiscount extends HTMLElement {
    connectedCallback() {
      if (this._pret) return;
      this._pret = true;
      var self = this;
      this.bouton = this.querySelector('.sh-discount__toggle');
      this.contenu = this.querySelector('.sh-discount__content');
      if (!this.bouton || !this.contenu) return;
      this.bouton.addEventListener('click', function () { self.basculer(); });
    }
    basculer() {
      var ouvert = this.bouton.getAttribute('aria-expanded') === 'true', c = this.contenu;
      var depart = c.getBoundingClientRect().height;
      var cible = ouvert ? 0 : c.scrollHeight;
      this.bouton.setAttribute('aria-expanded', ouvert ? 'false' : 'true');
      c.setAttribute('aria-hidden', ouvert ? 'true' : 'false');
      this.classList.toggle('is-open', !ouvert);
      if (reduit()) { c.style.transition = 'none'; c.style.height = ouvert ? '0px' : 'auto'; return; }
      c.style.transition = 'none';
      c.style.height = depart + 'px';
      void c.offsetHeight;
      c.style.transition = '';
      c.style.height = cible + 'px';
      var fini = function (e) {
        if (e.target !== c || e.propertyName !== 'height') return;
        c.removeEventListener('transitionend', fini);
        if (c.getAttribute('aria-hidden') === 'false') c.style.height = 'auto';
      };
      c.addEventListener('transitionend', fini);
    }
  }
  definir('sh-discount', ShDiscount);

  /* ------------------------------------------------------------------ barre d'achat collante */
  class ShStickyBuy extends HTMLElement {
    connectedCallback() {
      if (this._pret) return;
      this._pret = true;
      var self = this;
      this.produit = this.closest('sh-product');
      this._maj = function () {
        if (self._raf) return;
        self._raf = requestAnimationFrame(function () { self._raf = 0; self.maj(); });
      };
      window.addEventListener('scroll', this._maj, { passive: true });
      window.addEventListener('resize', this._maj);
      setTimeout(this._maj, 50);
    }
    disconnectedCallback() {
      window.removeEventListener('scroll', this._maj);
      window.removeEventListener('resize', this._maj);
    }
    pied() {
      if (this._pied && document.body.contains(this._pied)) return this._pied;
      this._pied = document.querySelector('.shopify-section-group-footer-group') || document.querySelector('footer');
      return this._pied;
    }
    maj() {
      var bloc = this.produit && this.produit.querySelector('[data-sh-main-buy] [type="submit"]');
      if (!bloc) return;
      var h = window.innerHeight, r = bloc.getBoundingClientRect();
      var boutonVu = r.bottom > 0 && r.top < h && r.height > 0;
      // la barre part dès que le haut du pied de page entre dans l'écran, et non quand il touche la barre (relevé par
      // pas de 10 px le 04/10, sonde_barre_seuils.py : la référence la retire à 842 px sur 844 au téléphone, à 898 px
      // sur 900 à l'ordinateur, et la remet dès que le pied ressort)
      var pied = this.pied();
      var piedAtteint = pied ? pied.getBoundingClientRect().top < h : false;
      var montrer = !boutonVu && !piedAtteint;
      if (montrer !== this.classList.contains('is-visible')) {
        this.classList.toggle('is-visible', montrer);
        this.setAttribute('aria-hidden', montrer ? 'false' : 'true');
        document.documentElement.classList.toggle('sh-sticky-buy-on', montrer);
        emit(this, montrer ? 'sh:sticky-buy:show' : 'sh:sticky-buy:hide', {});
      }
    }
  }
  definir('sh-sticky-buy', ShStickyBuy);

  /* ------------------------------------------------------------------ la fiche */
  function nomOption(set) {
    var n = set.querySelector('.sh-variants__name');
    return n ? n.textContent.replace(':', '').trim().toLowerCase() : '';
  }
  function appliquerVariante(racine, picker, v, opts, majAdresse) {
    if (!v) return;
    qsa('[data-sh-variant-id]', racine).forEach(function (champ) { champ.value = v.id; });
    qsa('sh-buy-form [type="submit"]', racine).forEach(function (b) {
      b.disabled = !v.available;
      var lib = b.querySelector('[data-sh-buy-label]');
      if (lib) lib.textContent = v.available ? 'Add to cart' : 'Sold out';
    });
    var sets = qsa('.sh-variants__set', picker), couleur = null;
    sets.forEach(function (set, i) { var n = nomOption(set); if (n === 'colour' || n === 'color') couleur = opts[i]; });
    if (couleur != null) {
      qsa('sh-gallery', racine).forEach(function (g) {
        if (g.getAttribute('data-colour') !== couleur && g.setColour) g.setColour(couleur);
      });
    }
    // prix (identique pour toutes les tailles aujourd'hui ; suit la variante s'il change)
    if (v.price != null && S.money) {
      qsa('[data-sh-price] .sh-price__amount, [data-sh-price] [data-sh-amount]', racine).forEach(function (p) { p.textContent = S.money(v.price); });
    }
    // barre collante : options et vignette de la couleur
    (v.options || []).forEach(function (o, i) {
      qsa('[data-sh-sticky-option="' + (i + 1) + '"]', racine).forEach(function (s) { s.textContent = o; });
    });
    var g = racine.querySelector('.sh-pdp__media sh-gallery'), img = g && g.premiereImage ? g.premiereImage() : null;
    var vign = racine.querySelector('[data-sh-sticky-media] img');
    if (img && vign) {
      // la première vue peut être l'image vide de 1 px de son <picture> (galerie cachée à cette largeur) : on prend
      // alors son src, et dans tous les cas la copie de 180 px (vignette de 53 px)
      var source = img.currentSrc && img.currentSrc.indexOf('data:') !== 0 ? img.currentSrc : img.src;
      vign.src = source.replace(/([?&]width=)\d+/, '$1180');
      vign.removeAttribute('srcset');
      vign.alt = img.alt;
    }
    if (majAdresse) {
      var u = new URL(window.location.href);
      u.searchParams.set('variant', v.id);
      try { history.replaceState(history.state, '', u.pathname + u.search + u.hash); } catch (e) { /* rien */ }
    }
  }
  class ShProduct extends HTMLElement {
    connectedCallback() {
      if (this._pret) return;
      this._pret = true;
      var self = this;
      this.addEventListener('sh:variant:change', function (e) {
        var d = e.detail || {};
        appliquerVariante(self, d.picker, d.variant, d.options || [], true);
      });
      // colonne d'achat : 20 px du haut au chargement, puis 20 px sous l'en-tête dès le premier défilement (référence,
      // relevé du 03/10, sonde_haut_collant.py) ; la règle « en-tête caché » est dans sh-product.css
      var premier = function () {
        self.classList.add('is-scrolled');
        window.removeEventListener('scroll', premier);
      };
      window.addEventListener('scroll', premier, { passive: true });
    }
  }
  definir('sh-product', ShProduct);

  /* ------------------------------------------------------------------ onglets des points clés */
  class ShKeyTabs extends HTMLElement {
    connectedCallback() {
      if (this._pret) return;
      this._pret = true;
      var self = this;
      this.section = this.closest('.sh-keys') || this;
      this.onglets = qsa('[role="tab"]', this);
      this.panneaux = qsa('[role="tabpanel"]', this);
      this.formes = qsa('.sh-keys__shape', this.section);
      this.actif = 0;
      // forme 1 : tracée quand la section entre dans l'écran (référence : départ quand le haut de la section passe
      // vers 85 % de la hauteur de l'écran, sonde_trace_partiel.py)
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entrees) {
          if (!entrees.some(function (e) { return e.isIntersecting; })) return;
          io.disconnect();
          var f = self.formes[self.actif];
          if (f) { f.style.opacity = '1'; self.tracer(f); }
        }, { rootMargin: '0px 0px -15% 0px' });
        io.observe(this.section);
      } else if (this.formes[0]) {
        this.formes[0].style.opacity = '1';
        this.tracer(this.formes[0]);
      }
      this.onglets.forEach(function (b, i) {
        b.addEventListener('click', function () { self.montrer(i); });
        b.addEventListener('keydown', function (e) {
          var k = e.key, n = self.onglets.length, j = null;
          if (k === 'ArrowRight' || k === 'ArrowDown') j = (i + 1) % n;
          if (k === 'ArrowLeft' || k === 'ArrowUp') j = (i - 1 + n) % n;
          if (j != null) { e.preventDefault(); self.onglets[j].focus(); self.montrer(j); }
        });
      });
    }
    montrer(i) {
      if (i === this.actif || this._enCours) return;
      var self = this, ancien = this.panneaux[this.actif], neuf = this.panneaux[i];
      var formeA = this.formes[this.actif], formeN = this.formes[i];
      this.onglets.forEach(function (b, j) {
        b.classList.toggle('is-active', j === i);
        b.setAttribute('aria-selected', j === i ? 'true' : 'false');
        b.tabIndex = j === i ? 0 : -1;
      });
      var precedent = this.actif;
      this.actif = i;
      this._enCours = true;
      var sortie = { duration: 300, easing: 'cubic-bezier(0, 0, 0.58, 1)', fill: 'forwards' };
      // fondu de la forme : 300 ms « ease » (relevé en animations réduites, sonde_reduit.py : 0,75 / 0,37 / 0,18 / 0,06)
      this.changerForme(formeA, formeN, { duration: 300, easing: 'ease', fill: 'forwards' });
      var aSortie = animer(ancien, [{ opacity: 1, transform: 'translateY(0)' }, { opacity: 0, transform: 'translateY(20px)' }], sortie);
      aSortie.finished.then(function () {
        ancien.hidden = true;
        ancien.classList.remove('is-active');
        if (aSortie.cancel) aSortie.cancel();
        ancien.style.opacity = ''; ancien.style.transform = '';
        neuf.hidden = false;
        neuf.classList.add('is-active');
        var aEntree = animer(neuf, [{ opacity: 0, transform: 'translateY(20px)' }, { opacity: 1, transform: 'translateY(0)' }],
          { duration: 300, easing: 'cubic-bezier(0, 0, 0.3, 1)' });
        aEntree.finished.then(function () { neuf.style.opacity = ''; neuf.style.transform = ''; self._enCours = false; });
        if (precedent === null) self._enCours = false;
      });
    }
    // l'ancienne forme s'efface en 300 ms, puis la nouvelle paraît et se trace ; en animations réduites aussi (la
    // référence n'y coupe que le fondu des panneaux)
    changerForme(a, n, sortie) {
      var self = this;
      var suite = function () {
        self.formes.forEach(function (f) {
          if (f === n) return;
          if (f.getAnimations) f.getAnimations().forEach(function (x) { x.cancel(); });
          f.style.opacity = '0';
          self.effacer(f);
        });
        if (n) { n.style.opacity = '1'; self.tracer(n); }
      };
      if (a && a.animate && getComputedStyle(a).opacity !== '0') {
        var anim = a.animate([{ opacity: 1 }, { opacity: 0 }], sortie);
        anim.onfinish = suite;
      } else {
        suite();
      }
    }
    effacer(f) {
      var p = f.querySelector('path');
      f.classList.add('is-instant');
      f.classList.remove('is-drawn');
      if (p) void getComputedStyle(p).strokeDashoffset;
      f.classList.remove('is-instant');
    }
    tracer(f) {
      this.effacer(f);
      f.classList.add('is-drawn');
    }
  }
  definir('sh-key-tabs', ShKeyTabs);

  /* ------------------------------------------------------------------ « You may also like » */
  class ShRelated extends HTMLElement {
    connectedCallback() {
      if (this._pret) return;
      this._pret = true;
      var self = this;
      this.slider = this.querySelector('sh-slider');
      if (!this.slider || !('IntersectionObserver' in window)) return;
      // Le carrousel se place sur sa deuxième carte hors de l'écran, quand son haut arrive à 300 px sous le bas de
      // l'écran : relevé sur la référence le 04/10 (sonde_suggestions_saut.py : 299 px sous l'écran à 390 x 844, à
      // 390 x 700 et à 1024 x 900, dans les deux modes). Fait plus tard, le saut d'une carte se voyait en bas de l'écran.
      var io = new IntersectionObserver(function (entrees) {
        entrees.forEach(function (en) {
          if (!en.isIntersecting) return;
          io.disconnect();
          if (self.slider.mesurer) self.slider.mesurer();
          if ((self.slider.max || 0) >= 1 && self.slider.index === 0) self.slider.go(1, false);
        });
      }, { threshold: 0, rootMargin: '0px 0px 300px 0px' });
      io.observe(this.slider);
    }
  }
  definir('sh-related', ShRelated);

  /* ------------------------------------------------------------------ quick view */
  function urlProduit(x) {
    if (!x) return null;
    if (/^https?:|^\//.test(x)) return x.split('?')[0];
    return '/products/' + x;
  }
  var QV = S.quickView = S.quickView || {};
  QV.open = function (cible, opts) {
    opts = opts || {};
    var url = urlProduit(cible);
    var tiroir = document.querySelector('sh-drawer[name="quickview"]');
    if (!url || !tiroir) { if (url) window.location.href = url; return Promise.resolve(); }
    if (QV._encours === url) return QV._promesse;
    var corps = tiroir.querySelector('[data-sh-qv-body]');
    var declencheur = opts.trigger || document.activeElement;
    if (declencheur && declencheur.setAttribute) declencheur.setAttribute('aria-expanded', 'true');
    QV._encours = url;
    var charger = S.sections && S.sections.fetch ? S.sections.fetch(url, 'sh-quick-view')
      : fetch(url + '?section_id=sh-quick-view', { credentials: 'same-origin' }).then(function (r) { return r.text(); });
    QV._promesse = charger.then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var neuf = doc.querySelector('[data-sh-qv-body]');
      if (neuf && corps) {
        // le contenu arrive dans un <template> inerte (sh-quick-view.liquid) : on le déballe
        var modele = neuf.querySelector('template[data-sh-qv-modele]');
        corps.innerHTML = modele ? modele.innerHTML : neuf.innerHTML;
        corps.scrollTop = 0;
      }
      QV._encours = null;
      if (S.drawers && S.drawers.open) S.drawers.open('quickview', { retour: declencheur });
      else tiroir.setAttribute('open', '');
      emit(tiroir, 'sh:quickview:loaded', { url: url });
    }).catch(function () {
      QV._encours = null;
      window.location.href = url;
    });
    return QV._promesse;
  };
  QV.close = function () { if (S.drawers && S.drawers.close) S.drawers.close('quickview'); };
  document.addEventListener('sh:quickview:open', function (e) {
    var d = e.detail || {};
    QV.open(d.url || d.handle, { trigger: d.trigger });
  });
  // déclencheurs sans script de carte : [data-sh-quick-view="<poignée ou adresse>"]
  document.addEventListener('click', function (e) {
    var t = e.target && e.target.closest && e.target.closest('[data-sh-quick-view]');
    if (!t || e.defaultPrevented) return;
    e.preventDefault();
    QV.open(t.getAttribute('data-url') || t.getAttribute('data-sh-quick-view'), { trigger: t });
  });
  document.addEventListener('sh:drawer:close', function (e) {
    if (!e.detail || e.detail.name !== 'quickview') return;
    qsa('[data-sh-quick-view][aria-expanded="true"]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
  });
  // variante dans la quick view : galerie et formulaire, sans toucher à l'adresse
  document.addEventListener('sh:variant:change', function (e) {
    var racine = e.target && e.target.closest && e.target.closest('[data-sh-qv-root]');
    if (!racine) return;
    var d = e.detail || {};
    appliquerVariante(racine, d.picker, d.variant, d.options || [], false);
  });
})();
